import { render, staticRenderFns } from "./journalism.vue?vue&type=template&id=1ee24434&scoped=true&"
import script from "./journalism.vue?vue&type=script&lang=js&"
export * from "./journalism.vue?vue&type=script&lang=js&"
import style0 from "./journalism.vue?vue&type=style&index=0&id=1ee24434&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee24434",
  null
  
)

export default component.exports